<template>
    <div id="cliente-cadastro">
        <section id="content">
            <!--start container-->

            <div class="container">
                <div class="row">
                    <TituloPagina class="header ml-2" titulo="Editar evento" />
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <!--<h4 class="header">Editar evento do sistema</h4> -->
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <div class="row">
                                        <div class="col m12">
                                            <div>
                                                <h4 class="header2 font-weight-500">{{ agenda.pedido_visita_tipo+' - '+agenda.funcionario.pessoa.pessoa_nome }}</h4>
                                                <dl class="dl">
                                                    <dt>Data Marcada:</dt>
                                                    <dd>{{ getDataMarcada(agenda.pedido_visita_data) }}</dd>
                                                    <dt>Hora Marcada:</dt>
                                                    <dd>{{ getHoraMarcada(agenda.pedido_visita_data) }}</dd>
                                                    <dt>Resposável:</dt>
                                                    <dd>{{ agenda.funcionario.pessoa.pessoa_nome }}</dd>
                                                    <template v-if="agenda.pedido_historico_agenda && agenda.pedido_historico_agenda.pedido_historico_agenda_endereco">
                                                        <dt>Endereço:</dt>
                                                        <dd>{{ agenda.pedido_historico_agenda.pedido_historico_agenda_endereco }}</dd>
                                                    </template>
                                                </dl>
                                            </div>
                                            <div class="mt-3 col m4 s12">
                                                <label for="status_id">Motivo</label>
                                                <select class="browser-default" v-model="formData.status_id" id="status_id">
                                                    <option value="" disabled selected>Selecione ...</option>
                                                    <option :value="statusRemarcada">Remarcada</option>
                                                    <option :value="statusNaoCompareceu">Não estava presente</option>
                                                    <option :value="statusCancelada">Cancelada</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                               <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import { get, put } from '@/helpers/api';
    import MaskedInput from 'vue-masked-input';
    import { DONO, GERENTE, CORRETOR } from '@/constants/funcionarioCargo.js';
    import {
        STATUS_REMARCADA, STATUS_NAO_COMPARECEU, STATUS_CANCELADA
    } from '@/constants/visitaStatus.js';
    import Auth from '@/store/auth';
    import Message from '@/helpers/message';
    import TituloPagina from '@/components/common/TituloPagina';

    export default {
        components: {
            MaskedInput,
            TituloPagina
        },
        data: () => ({
            formData: {
                pedido_historico_id: '',
                status_id: ''
            },
            agenda: {},
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            showForm: false,
            statusRemarcada: STATUS_REMARCADA,
            statusNaoCompareceu: STATUS_NAO_COMPARECEU,
            statusCancelada: STATUS_CANCELADA
        }),
        created() {

            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;

            let self = this;
            get('pedido-historico/'+this.$route.params.id).then(function (response) {
                self.agenda = response.data.result.data;
                self.formData.pedido_historico_id = self.agenda.pedido_historico_id;
            });
        },
        methods: {
            save() {
                if (this.formData.status_id === '') {
                    Message.messageError('Selecione motivo.');
                    return;
                }

                let self = this;
                put('pedido-historico/atualizar-visita/'+this.formData.pedido_historico_id, {
                    status_id: this.formData.status_id
                }).then(function (response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/', function () {
                        location.reload();
                    });
                }).catch(function () {
                    Message.messageError('Ocorreu algum erro, tente novamente mias tarde.');
                })
            },
            getDataMarcada(data) {
                return moment(data).format('DD/MM/YYYY');
            },
            getHoraMarcada(data) {
                return moment(data).format('HH:mm');
            }
        }
    }
</script>


<style lang="scss" scoped>
.dl{
    padding: 0;
    dt, dd{
        margin: 0;
        padding-top: 5px;
    }

    dt{
        font-weight: bold;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/agenda-sistema/Editar.vue